import type {UpdateMaterialFunctionFormPayload} from "./update-material-function.schema";

import {updateMaterialFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {materialFunctionKeys, materialFunctionMutationKeys} from "../../../materialFunction-keys";

export function updateMaterialFunctionMutationOptions(materialFunctionId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateMaterialFunctionFormPayload) =>
      updateMaterialFunction(materialFunctionId, payload),
    mutationKey: materialFunctionMutationKeys.updateMaterialFunction,
    onSuccess: async (_data, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: materialFunctionKeys.detail(materialFunctionId)}),
        client.invalidateQueries({queryKey: materialFunctionKeys.lists()}),
      ]);
    },
  });
}
